import type {
  FlowEditorSDK,
  AppManifestBuilder,
  TFunction,
} from '@wix/yoshi-flow-editor';
import ActionsId from './utils/ActionsId';

export function configureManifest(
  appManifestBuilder: AppManifestBuilder,
  editorSDK: FlowEditorSDK,
  t: TFunction,
) {
  appManifestBuilder.configureManagementActions(
    async (managementActionsBuilder) => {
      managementActionsBuilder.mainActions().addAction(
        {
          title: t('business.addCategory'),
          icon: 'appManager_addElementsAction',
          actionId: ActionsId.ADD_CATEGORY,
        },
        {
          title: t('business.addQandA'),
          icon: 'appManager_addElementsAction',
          actionId: ActionsId.ADD_QUESTION,
        },
      );

      managementActionsBuilder.customActions().addAction({
        title: t('main.tab.btn.manage.questions'),
        icon: 'appManager_settingsAction',
        type: 'editorActions',
        actionId: ActionsId.MANAGE_FAQS,
      });

      managementActionsBuilder.learnMoreAction().set({
        id: 'cb0194e4-ed04-4b0a-9974-572da053819b',
      });
    },
  );
}
